import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { isBlank } from '../../helpers/stringHelper'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, CheckBox, Icon, Return, Select} from '../inspinia';
import { configAction } from '../../store/configUsuario';
import RemetentesList from './remetentesList';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { getToken } from '../../store/auth';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';


class Configuracao extends React.PureComponent
{
    
    constructor(props)
    {
        super(props);    
        
        this.state = 
        {
            loading: false,
            pageInit: 0,
            listaRemetentes: [],
            nomeDominio: "",
            idEdicao: null,
            domainDisabled: false,
            
            form: this.formInitialState(),
            list: 
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
            },
            comboRemetente: 
            {
                results: undefined
            },   
            comboNomeDominio:
            {
                results: undefined
            },  
            comboNomeDominiosAutoComplete: [],
            dominioValues: {
                id: "",
                url: ""
            },
            alerta: withReactContent(Swal)                  
        }

        this.remetentesListRef = React.createRef();

        this.handleChange                   = this.handleChange.bind(this);
        this.LoadSaveRemetente              = this.LoadSaveRemetente.bind(this);
        this.handleAdicionarRemetente       = this.handleAdicionarRemetente.bind(this);
        this.handleLimparCampos             = this.handleLimparCampos.bind(this);
        this.handleAdicionarLinkDescadastro = this.handleAdicionarLinkDescadastro.bind(this);
        this.handleAdicionarEmpresa         = this.handleAdicionarEmpresa.bind(this);
        this.onNomeDominioChange = this.onNomeDominioChange.bind(this);
        this.onRemetenteSelected = this.onRemetenteSelected.bind(this);

    }


    formInitialState () 
    {
        return {
            linkDescadastro: "",
            nomeRemetente: "",
            emailRemetente: "",
            nomeEmpresa: ",",
            idDominio: ",",
            urlDominio: ",",
            dominio: ""
        }
    }

    componentDidMount() {      
       this.LoadComboDominios();
    }

    handleChange(e) {

        const form = this.state.form;

     

            this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    
    }

    handleLimparCampos() {
        this.setState({
            idEdicao: null,
            domainDisabled: false,
            form: {
                ...this.formInitialState(),
                emailRemetente: '',
                linkDescadastro: '',
                nomeRemetente: '',
                dominio: ''
            },
            dominioValues: {
                idDominio: '',
                urlDominio: ''
            }
        });
    }    

    handleAdicionarRemetente() {
        
        this.LoadSaveRemetente();

    }

    onRemetenteSelected(remetente) {
        const [localPart, domainPart] = remetente.email.split('@'); 
      
        const dominioEncontrado = this.state.comboNomeDominiosAutoComplete.find(
          (dom) => dom.url === domainPart
        );
      
        const dominioValuesAtualizado = {
          id: dominioEncontrado ? dominioEncontrado.id : '',
          url: domainPart
        };
      
        this.setState({
          idEdicao: remetente.id, 
          domainDisabled: true,
          form: {
            ...this.state.form,
            nomeRemetente: remetente.nome,      
            emailRemetente: localPart,
            dominio: domainPart
          },
          dominioValues: dominioValuesAtualizado
        });
    }
           

    handleAdicionarLinkDescadastro() {
        
        this.LoadSaveLink();  
           
    }

    handleAdicionarEmpresa() {

        this.LoadEmpresa();

    }

    onNomeDominioChange = (event, values) => {
        const form = this.state.form;
        let dominioCombo = '';

        if (values) {
            dominioCombo = values.value;
        }

        this.setState({
             form: { ...form, dominio: dominioCombo },
             ...this.state, dominioValues: values});

    }

    LoadComboDominios() {
        let self = this;

        const url = `${c.API_BASE_URL}/listDominio`;
        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboNomeDominio: response, comboNomeDominiosAutoComplete: response });
        });
    }

    LoadSaveRemetente() {
        let self = this;
    
        if (isBlank(this.state.form.nomeRemetente) || isBlank(this.state.form.emailRemetente)) {
            c.TOASTER_INFO('Favor preencher os campos de remetente.');
            return;
        }
    
        const isEdicao = !!this.state.idEdicao;
    
        const method = isEdicao ? 'PUT' : 'POST';
    
        const body = isEdicao
          ? {
            id: this.state.idEdicao,
              nome: this.state.form.nomeRemetente,
              email: this.state.form.emailRemetente,
              idDominio: this.state.dominioValues.id,
              urlDominio: this.state.dominioValues.url
            }
          : {
              nome: this.state.form.nomeRemetente,
              email: this.state.form.emailRemetente,
              idDominio: this.state.dominioValues.id,
              urlDominio: this.state.dominioValues.url
            };
    
        const url = `${c.API_BASE_URL}/sender`;
        const _token = c.AUTH_HEADER(getToken());
    
        const options = {
          method: method,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': _token
          },
          body: JSON.stringify(body)
        };
    
        self.setState({ ...self.state, loading: true });
    
        fetch(url, options)
          .then(async (response) => {
            let json = await response.json();
            self.setState({ ...self.state, loading: false });
    
            if (response.ok) {
              const successMessage = isEdicao
                ? 'Remetente atualizado com sucesso!'
                : 'Remetente cadastrado com sucesso!';
    
                if (this.remetentesListRef.current) {
                    this.remetentesListRef.current.LoadRemetentes();
                }
                this.LoadComboDominios();
                this.handleLimparCampos();
    
              self.state.alerta.fire({
                icon: 'success',
                title: successMessage,
                text: json.message,
                showConfirmButton: false,
                timer: 1500
              });
            } else {
              self.state.alerta.fire({
                title: 'Erro ao salvar remetente',
                icon: 'error',
                text: json.message,
                confirmButtonColor: '#47A789'
              });
            }
          })
          .catch((exception) => {
            self.setState({ ...self.state, loading: false });
            console.error('fetch error', exception);
            self.state.alerta.fire({
              title: 'Erro ao salvar remetente',
              icon: 'error',
              text: 'Erro ao salvar remetente. Favor entrar em contato com o suporte.',
              confirmButtonColor: '#47A789'
            });
          });
    }

    LoadSaveLink()
    {
        let self = this;

        if(isBlank(this.state.form.linkDescadastro)) {
            c.TOASTER_INFO('Favor preencher os campos do link.');   

        } else {

            const url = `${ c.API_BASE_URL }/messageSalve`;
            const options =
            {
                method: 'POST'
                ,headers: { 'Content-Type': 'application/json' }
                ,body: JSON.stringify({            
                    linkDescadastro: this.state.form.linkDescadastro,              
                })
            };

            self.setState({...self.state, loading: true})

            callApi(url, options, function(response)
            { 
                self.setState({...self.state, loading: false}, self.handleLimparCampos());
                c.TOASTER_SUCCESS(response.message); 
            });

        }

       
    }

    handleKeyPress(e) {
        if (e.key === "@") {
            e.preventDefault();
        }
    }

    LoadEmpresa()
    {
        
    }


    
    render()
    {
        const form = this.state.form;
        const dominios = this.state.comboNomeDominiosAutoComplete;


        return (

            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column size="6">
                        <IBox>
                            <Title>
                                <h4 className="text-slate-grey">Remetentes</h4>
                            </Title>
    
                            <Content>
                                <Row className="m-0 mb-0">
                                    <div class="px-5 pt-4">
                                        <p class="fs-14 text-muted">
                                            Endereços de e-mail cadastrados que representam sua empresa  para os destinatários das suas campanhas:
                                        </p>  

                                        <RemetentesList
                                            ref={this.remetentesListRef}
                                            auth={this.props.auth}
                                            onRemetenteSelected={this.onRemetenteSelected}
                                        />

                                            <h3 class="text-center text-slate-grey fs-14 mb-4">
                                                Cadastrar novo e-mail 
                                            </h3>  

                                            <Content>
                                                
                                                <div class="form-group">
                                                    <input type="text" name="nomeRemetente" value={form.nomeRemetente} onChange={this.handleChange} placeholder="Nome do remetente" class="form-control"/>
                                                </div>

                                                <div class="form-group" style={{display: 'flex', justifyContent: 'space-between'}}>
                                                    <div style={{width: '49%'}}>
                                                        <input type="email" name="emailRemetente" value={form.emailRemetente} onChange={this.handleChange} onKeyPress={this.handleKeyPress} placeholder="E-mail do remetente" class="form-control"/>
                                                    </div>

                                                    <div style={{width: '10%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                        @
                                                    </div>

                                                    <div style={{width: '49%'}}>
                                                        <Autocomplete
                                                            id="combo-dominio"
                                                            options={dominios}
                                                            getOptionLabel={(option) => option.url}
                                                            style={{ marginTop: -8 }}
                                                            onChange={this.onNomeDominioChange}
                                                            value={this.state.dominioValues}
                                                            getOptionSelected={(option) => option.id}
                                                            disabled={this.state.domainDisabled}
                                                            renderInput={
                                                                (params) =>
                                                                    <TextField
                                                                        {...params}
                                                                        variant="outlined"
                                                                        margin="dense"
                                                                    />
                                                            }
                                                        />
                                                    </div>
                                                    
                                                </div>

                                                <div class="form-group container">
                                                    <div class="row">
                                                        <div class="col-1 m-0 px-1"><img src="assets/images/info.svg" class="text-info"/></div>
                                                    
                                                        <div class="col-11 m-0 px-0 text-muted">
                                                            <ul style={{listStyleType: "none", padding: 0}}>
                                                                <li>É necessário verificar o endereço de e-mail antes de usá-lo, para confirmar que ele realmente pertence a você.</li>
                                                                <br />
                                                                <li>Os endereços de e-mail devem ser válidos e ativos. E não podem ser nominais, como "marcos@suaempresa.com.br".</li>
                                                                <br />
                                                                <li>Se você acredita que o endereço de e-mail foi impedido de ser cadastrado indevidamente, entre em contato com o suporte.</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group row">
                                                    <div className="col-md-6 text-right">
                                                        <Button
                                                        onClick={this.handleAdicionarRemetente}
                                                        className="btn btn-primary"
                                                        style={{ marginLeft: '20px' }}
                                                        >
                                                        { this.state.idEdicao ? 'Salvar Alterações' : 'Incluir' }
                                                        </Button>
                                                    </div>

                                                    <div className="col-md-2 text-right">
                                                        <Button
                                                        onClick={this.handleLimparCampos}
                                                        className="btn btn-secondary"
                                                        style={{ marginRight: '20px' }}
                                                        >
                                                        <Icon name="far fa-trash" /> Limpar
                                                        </Button>
                                                    </div>
                                                </div>
   

                                            </Content>

                                    </div>    

                                </Row>
                            </Content>

                        </IBox>
                       
                    </Column>


                    <Column size="6">
                        <IBox>
                            <Title>
                                <h4 className="text-slate-grey">Link de descadastro obrigatório</h4>
                            </Title>                            
                        
                            <Content>

                                <Row className="m-0 mb-0">

                                    <div class="px-5 pt-4">
                                        <p class="fs-14 text-muted">
                                            Preencha com o link de descadastro que o seu CRM fornece e depois insira a variável de E-MAIL na posição adequada.
                                        </p>

                                        <div class="form-group">
                                            <input type="text" name="linkDescadastro" value={form.linkDescadastro} onChange={this.handleChange} class="form-control" placeholder="https://"/>
                                        </div>

                                        <div class="form-group">
                                            <span class="fs-14 fw-600 font-roboto text-body mr-2">Tags:</span>

                                            <a class="fs-12 fw-400 font-roboto text-grey"><u>*E-MAIL*</u></a>
                                        </div>

                                        <div class="form-group text-center">
                                            <Button onClick={this.handleAdicionarLinkDescadastro} class="btn btn-primary">Salvar</Button>                          
                                        </div>
                                    </div>                                                                           

                                </Row>

                            </Content>
                        </IBox>

                    </Column>


                </Row>

            </div>

        );
    }


}

function mapStateToProps(state)
{
    return { auth: state.auth, config: state.config };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { config: bindActionCreators(configAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Configuracao));
